import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Component({
    selector: 'app-input-hint',
    templateUrl: './input-hint.component.html',
    styleUrls: ['./input-hint.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputHintComponent {

    @Input() control?: AbstractControl;

}
